function SequenceDetailsBlock(params) {
  var self = this;

  self.sequenceInfo = params.sequenceInfo;
}

module.exports = SequenceDetailsBlock;
